(() => {
  const KEY = 'q974_recently_viewed';
  const MAX_STORED = 12;

  const readHandles = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter((item) => typeof item === 'string' && item) : [];
    } catch (error) {
      return [];
    }
  };

  const saveCurrent = (current, handles) => {
    if (!current) return;
    const next = [current, ...handles.filter((handle) => handle !== current)].slice(0, MAX_STORED);
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (error) { /* storage can be unavailable */ }
  };

  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    } catch (error) {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  };

  const createText = (tag, className, text) => {
    const element = document.createElement(tag);
    element.className = className;
    element.textContent = text;
    return element;
  };

  const productCard = (product, root, currency, soldOutText) => {
    const card = document.createElement('article');
    card.className = 'q974-recently-viewed__card';

    const url = `${root}products/${encodeURIComponent(product.handle)}`;
    const media = document.createElement('a');
    media.className = 'q974-recently-viewed__media';
    media.href = url;

    const source = product.featured_image || (Array.isArray(product.images) ? product.images[0] : '');
    if (source) {
      const image = document.createElement('img');
      image.className = 'q974-recently-viewed__image';
      image.src = source;
      image.alt = product.title || '';
      image.loading = 'lazy';
      image.width = 700;
      image.height = 850;
      media.appendChild(image);
    }

    if (!product.available) media.appendChild(createText('span', 'q974-recently-viewed__sold-out', soldOutText));
    card.appendChild(media);

    const info = document.createElement('div');
    info.className = 'q974-recently-viewed__info';
    if (product.vendor) info.appendChild(createText('p', 'q974-recently-viewed__vendor', product.vendor));

    const title = createText('a', 'q974-recently-viewed__name', product.title || '');
    title.href = url;
    info.appendChild(title);

    const price = document.createElement('p');
    price.className = 'q974-recently-viewed__price';
    price.append(document.createTextNode(money(Number(product.price || 0), currency)));
    const compareValue = Number(product.compare_at_price || 0);
    if (compareValue > Number(product.price || 0)) {
      const compare = createText('s', 'q974-recently-viewed__compare', money(compareValue, currency));
      price.appendChild(compare);
    }
    info.appendChild(price);
    card.appendChild(info);
    return card;
  };

  const init = async (section) => {
    if (section.dataset.q974Ready === 'true') return;
    section.dataset.q974Ready = 'true';

    const current = section.dataset.currentHandle || '';
    const allHandles = readHandles();
    const candidates = allHandles.filter((handle) => handle !== current).slice(0, Number(section.dataset.limit || 4));
    saveCurrent(current, allHandles);

    if (!candidates.length) {
      if (section.dataset.designMode !== 'true') section.hidden = true;
      return;
    }

    const root = section.dataset.root || '/';
    const currency = section.dataset.currency || 'QAR';
    const soldOutText = section.dataset.soldOut || 'Sold out';
    const grid = section.querySelector('[data-q974-recent-grid]');
    if (!grid) return;

    const products = await Promise.all(candidates.map(async (handle) => {
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
        if (!response.ok) return null;
        return await response.json();
      } catch (error) {
        return null;
      }
    }));

    products.filter(Boolean).forEach((product) => grid.appendChild(productCard(product, root, currency, soldOutText)));
    if (!grid.children.length && section.dataset.designMode !== 'true') section.hidden = true;
  };

  const initAll = (root = document) => root.querySelectorAll('[data-q974-recently-viewed]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
